import ZkDropdownItem from '../dropdown/src/dropdown-item';

/* istanbul ignore next */
ZkDropdownItem.install = function(Vue) {
  Vue.component(ZkDropdownItem.name, ZkDropdownItem);
};

export default ZkDropdownItem;



// WEBPACK FOOTER //
// ./src/packages/dropdown-item/index.js